enum BucketName {
    Samples = "samples",
}

export { BucketName };
